<template>
  <div class="app-container1">
    <div class="my-tree">
      <!-- 搜索框 -->
      <div class="tree-search">
        <el-input 
          placeholder="输入关键字进行过滤" 
          v-model="filterText"
          size="small"
          clearable
          prefix-icon="el-icon-search"
        >
        </el-input>
      </div>
      
      <!-- 树形组件，包含简约滚动功能 -->
      <div class="tree-container" ref="treeContainer">
        <el-tree 
          highlight-current 
          ref="tree" 
          node-key="id" 
          v-loading="treeLoading" 
          :data="treeData"
          @node-click="handleNodeClick" 
          :props="defaultProps" 
          default-expand-all 
          :expand-on-click-node="false"
          :filter-node-method="filterNode"
        ></el-tree>
      </div>
    </div>
    
    <div class="right-content">
      <tuopoVue :RecordID="recordid"></tuopoVue>
    </div>
  </div>
</template>

<script>
import tuopoVue from "./components/tuopo.vue";
import pageMixin from "@/mixins/pageMixin"
import fileUpload from "@/components/fileUpload/fileUpload.vue"
import { GetLeftTree } from "@/api/dev_archive"
import { mapGetters } from "vuex"

export default {
  name: "GroupManage",
  mixins: [pageMixin],
  components: { tuopoVue, fileUpload },
  data() {
    return {
      recordid: "1018542817800192", // 默认值
      filterText: "", // 搜索过滤文本
      visible: {
        editGroup: false
      },
      tableData: [],
      filter: {
        groupName: ""
      },
      defaultProps: {
        children: "children",
        label: "Text", // 注意：这里对应后端返回的Text字段
      },
      treeData: [
        {
          label: "全部",
          id: "",
          children: [],
        },
      ],
      treeLoading: false,
      loading: false,
      isUpdate: true,
      gid: "", // 街道id
    }
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  watch: {
    // 监听filterText变化，实现树节点过滤
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  created() {
    this.getData();
  },
  mounted() {
    // 监听窗口大小变化
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    // 移除事件监听
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    // 处理窗口大小变化
    handleResize() {
      // 可以在这里添加响应式逻辑
    },
    
    // 树节点过滤方法
    filterNode(value, data) {
      if (!value) return true;
      // 根据Text字段进行过滤
      return data.Text && data.Text.indexOf(value) !== -1;
    },

    // 处理树节点点击事件
    handleNodeClick(data, node) {
      // 判断节点类型是否为"站点"
      if (data.label === "站点") {
        // 如果是站点节点，将其id赋值给recordid
        this.recordid = data.id;
      }
    },

    getData() {
      this.treeLoading = true;
      GetLeftTree({
        // 参数根据实际接口需要传递
      })
        .then((res) => {
          this.treeData = res.tree || [];
          console.log("获取到的树数据:", this.treeData);
        })
        .catch((error) => {
          console.error("获取树数据失败:", error);
        })
        .finally(() => {
          this.treeLoading = false;
        });
    },
  }
}
</script>

<style scoped>
.app-container1 {
  display: flex;
  flex-direction: row;
  height: 87vh;
  border-radius: 5px;
  overflow: hidden;
}

.my-tree {
  position: relative;
  width: 18%;
  padding: 10px;
  background: #fff;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.tree-search {
  margin-bottom: 10px;
  flex-shrink: 0;
}

.tree-container {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  background-color: #fff;
  min-height: 300px;
  
  /* 极简滚动条样式 */
  &::-webkit-scrollbar {
    width: 4px;
  }
  
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #dcdfe6;
    border-radius: 2px;
  }
  
  /* 鼠标悬停时显示滚动条 */
  &::-webkit-scrollbar {
    opacity: 0;
    transition: opacity 0.3s;
  }
  
  &:hover::-webkit-scrollbar {
    opacity: 1;
  }
  
  /* Firefox滚动条 */
  scrollbar-width: thin;
  scrollbar-color: #dcdfe6 transparent;
}

.right-content {
  margin-left: 10px;
  width: 81.5%;
  border-radius: 5px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

/* 树节点样式优化 */
::v-deep .el-tree {
  padding: 4px 8px;
  min-height: 100%;
}

::v-deep .el-tree-node {
  margin-bottom: 1px;
}

::v-deep .el-tree-node__content {
  height: 34px;
  line-height: 34px;
  border-radius: 3px;
  transition: all 0.2s;
  padding: 0 6px;
}

::v-deep .el-tree-node__content:hover {
  background-color: #f8f9fa;
}

::v-deep .el-tree-node.is-current > .el-tree-node__content {
  background-color: #f0f7ff;
  color: #409eff;
}

::v-deep .el-tree-node__label {
  font-size: 13px;
  user-select: none;
}

::v-deep .el-tree-node__expand-icon {
  color: #c0c4cc;
  font-size: 12px;
}

::v-deep .el-tree-node__expand-icon.is-leaf {
  color: transparent;
  cursor: default;
}

/* 加载状态样式 */
::v-deep .el-tree__empty-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
  color: #909399;
  font-size: 13px;
}

/* 响应式调整 */
@media (max-width: 1200px) {
  .my-tree {
    width: 22%;
  }
  
  .right-content {
    width: 77%;
  }
}

@media (max-width: 992px) {
  .app-container1 {
    flex-direction: column;
    height: auto;
  }
  
  .my-tree {
    width: 100%;
    margin-bottom: 10px;
    height: 400px;
  }
  
  .right-content {
    width: 100%;
    margin-left: 0;
  }
}
</style>